import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const QuiltTimeContext = createContext({
  asOfEnabled: true,
  asOfDate: new Date(),
  liveEnabled: true,
  filterMode: "asOf",
  rangeStart: new Date(),
  rangeEnd: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  setAsOfEnabled: () => {},
  setAsOfDate: () => {},
  setLiveEnabled: () => {},
  setFilterMode: () => {},
  setRangeStart: () => {},
  setRangeEnd: () => {},
  setRangeToNextWeek: () => {},
  setRangeToNextMonth: () => {},
  setAsOfNow: () => {},
});

export function QuiltTimeProvider({ children }) {
  const [asOfEnabled, setAsOfEnabled] = useState(true);
  const [asOfDate, setAsOfDate] = useState(() => new Date());
  const [liveEnabled, setLiveEnabled] = useState(true);
  const [filterMode, setFilterMode] = useState("asOf");
  const [rangeStart, setRangeStart] = useState(() => new Date());
  const [rangeEnd, setRangeEnd] = useState(() => new Date(Date.now() + 7 * 24 * 60 * 60 * 1000));

  useEffect(() => {
    if (!liveEnabled) return undefined;
    const intervalId = window.setInterval(() => {
      setAsOfDate(new Date());
    }, 1000);
    return () => window.clearInterval(intervalId);
  }, [liveEnabled]);

  const value = useMemo(() => ({
    asOfEnabled,
    asOfDate,
    liveEnabled,
    filterMode,
    rangeStart,
    rangeEnd,
    setAsOfEnabled,
    setAsOfDate,
    setLiveEnabled,
    setFilterMode,
    setRangeStart,
    setRangeEnd,
    setRangeToNextWeek: () => {
      const now = new Date();
      setRangeStart(now);
      setRangeEnd(new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000));
    },
    setRangeToNextMonth: () => {
      const now = new Date();
      setRangeStart(now);
      setRangeEnd(new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000));
    },
    setAsOfNow: () => {
      setAsOfDate(new Date());
      setLiveEnabled(true);
    },
  }), [asOfEnabled, asOfDate, liveEnabled, filterMode, rangeStart, rangeEnd]);

  return (
    <QuiltTimeContext.Provider value={value}>
      {children}
    </QuiltTimeContext.Provider>
  );
}

export function useQuiltTime() {
  return useContext(QuiltTimeContext);
}
